import { z } from "zod";

/**
 * MaquinasequipControleSchema
 */

export const MaquinasequipControleSchema = z.object({
  idCentroCusto: z.coerce.number(),
});

/**
 * MaquinasequipControleForm
 */

export type MaquinasequipControleForm = z.infer<typeof MaquinasequipControleSchema>;
